export default {
      id: "pdf-csr-usage",
      viewBox: "0 0 25 25",
      url: __webpack_public_path__ + "sprite.svg#pdf-csr",
      toString: function () {
        return this.url;
      }
    }